

































import { Component, Vue, Ref, Mixins } from "vue-property-decorator";
import VMap from "@/components/Scouting/Map.vue";
import GroupSidebar from "@/components/Analysis/GroupSidebar.vue";
import { currentScoutingStore } from "@/store/typed";
import { ScoutingAnalysis } from "@/models/Scouting";
import { ScoutingArea, ScoutingPlace } from "@/models";
import { GOOGLE_MAPS_API_KEY } from "@/utils/Constants";
import { ScoutingGroupCreateDTO } from "@/models/ScoutingGroup";
import ScoutingGroupMixin from "@/mixins/http/ScoutingGroupMixin";
import ScoutingGroupHelperMixin from "@/mixins/ScoutingGroupHelperMixin";

@Component({
  components: {
    VMap,
    GroupSidebar,
  },
})
export default class Edit extends Mixins(
  ScoutingGroupHelperMixin,
  ScoutingGroupMixin
) {
  async mounted() {
    await this.loadGoogleMaps();

    this.analysis =
      currentScoutingStore.scoutingAnalysis ||
      (await currentScoutingStore.loadScoutingAnalysis(this.analysisId)) ||
      null;

    if (this.groupType === "area") {
      this.loadMapAreas();
    }
    if (this.groupType === "place") {
      this.loadMapPlaces();
    }
  }

  get scoutingGroup() {
    return this.analysis?.scouting.scoutingGroups.find(
      (e) => e.id === this.$route.params.groupId
    );
  }

  get groupType() {
    return this.scoutingGroup?.groupType;
  }

  goBack() {
    this.$router.push({
      name: "company_analysis",
      params: {
        id: this.companyId,
        analysisId: this.analysisId,
      },
    });
  }

  loadMapPlaces() {
    if (!this.scoutingGroup) {
      return;
    }

    const places = this.scoutingGroup.scoutingPlaces;

    for (const place of places) {
      this.addScoutingPlaceToMap(place);
      this.selectedPlaces.push(place);
    }

    this.map.centerOnPlaces(this.selectedPlaces);
  }

  loadMapAreas() {
    if (!this.scoutingGroup) {
      return;
    }

    const areas = this.scoutingGroup.scoutingAreas;

    for (const area of areas) {
      this.addScoutingAreaToMap(area);
      this.selectedAreas.push(area);
    }

    this.map.centerOnAreas();
  }

  async save(payload: ScoutingGroupCreateDTO) {
    if (!this.scoutingGroup || !this.analysis) {
      return;
    }
    const updatedScoutingGroup = await this.updateScoutingGroup(
      this.scoutingGroup.id,
      payload
    );
    const groups = this.analysis?.scouting.scoutingGroups;
    groups?.splice(
      groups?.findIndex((e) => e.id === updatedScoutingGroup.id),
      1,
      updatedScoutingGroup
    );
    currentScoutingStore.setScoutingAnalysis(this.analysis);
    this.goBack();
  }
}
